import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Link, useLocation, useNavigate, useParams } from 'react-router-dom';
import Sidebar from '../components/Sidebar';
import { FiEdit, FiX, FiZoomIn } from "react-icons/fi";
import { BeatLoader } from 'react-spinners';
import toast, { Toaster } from 'react-hot-toast';
import { API } from '../../api/Api';
import { IoMdArrowBack } from "react-icons/io";
import { GrNext, GrPrevious } from 'react-icons/gr';
import Select, { components } from 'react-select';
import { MdOutlineDeleteOutline } from 'react-icons/md';
import { FaPlus } from "react-icons/fa6";
const OptionWithCheckbox = (props) => {
    return (
        <components.Option {...props}>
            <input
                type="checkbox"
                checked={props.isSelected}
                onChange={() => null}
                className="mr-2"
            />
            <label>{props.label}</label>
        </components.Option>
    );
};
const ColorSelection = () => {
    const token = localStorage.getItem('token');

    const { id } = useParams();
    const location = useLocation();

    const [loading, setLoading] = useState(false);
    const [deleteLoading, setDeleteLoading] = useState(false);
    const [apiData, setApiData] = useState([]);
    const [previewImage, setPreviewImage] = useState(null);
    const [oldImage, setOldImage] = useState(null);
    const [isImageModalOpen, setIsImageModalOpen] = useState(false);
    const [addCategoryLoading, setAddCategoryLoading] = useState(false);
    const [colorLoading, setColorLoading] = useState(false);
    const [searchQuery, setSearchQuery] = useState('');
    const [submitLoading, setSubmitLoading] = useState(false);
    const [editImage, setEditImage] = useState(null);
    const [zoomImage, setZoomImage] = useState(null);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [colorToDelete, setColorToDelete] = useState(null);
    const [uploadedFile, setUploadedFile] = useState(null);

    const [orderUpdating, setOrderUpdating] = useState(false);
    const [openRow, setOpenRow] = useState(null);

    const [inProgressRows, setInProgressRows] = useState([]);
    const [selectedRows, setSelectedRows] = useState([]);
    const [selectAll, setSelectAll] = useState(false);
    const [groups, setGroups] = useState([]);
    const [collections, setCollections] = useState([]);
    const [layouts, setLayoutOptions] = useState([]);
    const [stylesOption, setStyleTypeOptions] = useState([]);
    const [rowAddingLayout, setRowAddingLayout] = useState(null);
    const [newLayouts, setNewLayouts] = useState([]);
    const [showLayoutModal, setShowLayoutModal] = useState(false);
    const [editingColorCode, setEditingColorCode] = useState(null); 
     const [editingColorCodeValue, setEditingColorCodeValue] = useState('');
    const [formData, setFormData] = useState({
        id: 0,
        name: '',
        //api_collection_id: "",
        layout: [],
        color_code:'',
        group: '',
        collection: '',
        visualizer_style_type_id: '',
        is_default: '0',
        have_grain: '0',
        is_high_gloss: '0',
        texture_file: null,
        texture_file_path: null,
        status: '1',
    });


    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage] = useState(20);

    const resetFormData = () => {
        setFormData({
            id: 0,
            name: '',
            //api_collection_id: "",
            layout: [],
            color_code:'',
            group: '',
            collection: '',
            visualizer_style_type_id: '',
            is_default: '0',
            have_grain: '0',
            is_high_gloss: '0',
            texture_file: null,
            texture_file_path: null,
            status: '1',
        });

        setSelectedCategoryId('');
        setErrors({});
    };


    // const location = useLocation();
    const navigate = useNavigate();

    const [addColorPopup, setAddColorPopup] = useState(false);

    const fetchColorsDetails = async () => {
        const baseURl = process.env.REACT_APP_API_URL;
        const apiPath = '/visualizer/colors';
        const url = `${baseURl}${apiPath}`;
        const requestBody = { status: "Active,De-active" };

        try {
            setColorLoading(true);
            const response = await API(url, requestBody, token);
            if (response) {
                setApiData(response.Result_value);


            }
        } catch (error) {
            console.error('Error during authentication:', error);
        } finally {
            setColorLoading(false);
        }
    };




    const fetchCategoryList = async () => {
        const baseURl = process.env.REACT_APP_API_URL;
        const apiPath = '/visualizer/getcolormasterlist';
        const url = `${baseURl}${apiPath}`;

        try {
            setLoading(true);

            // 1. Groups
            const groupRes = await API(url, { type: "group" }, token);
            setGroups(groupRes?.Data || []);

            // 2. Collections
            const collectionRes = await API(url, { type: "collection" }, token);
            setCollections(collectionRes?.Data || []);

            // 3. Layouts
            const layoutRes = await API(url, { type: "layout" }, token);
            setLayoutOptions(layoutRes?.Data || []);

            // 4. Style Types
            const styleRes = await API(url, { type: "styletype" }, token);
            setStyleTypeOptions(styleRes?.Data || []);

        } catch (error) {
            console.error("Error fetching dropdown data:", error);
        } finally {
            setLoading(false);
        }
    };



    useEffect(() => {
        fetchColorsDetails();
        fetchCategoryList();
    }, []);


    const [errors, setErrors] = useState({});
    const [selectedCategoryId, setSelectedCategoryId] = useState('');

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        const val = type === 'checkbox' ? (checked ? '1' : '0') : value;
        setFormData({
            ...formData,
            [name]: val,
        });




        setErrors((prevErrors) => ({
            ...prevErrors,
            [name]: undefined,
        }));
    };

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        const { name } = e.target;
        setFormData({
            ...formData,
            [name]: file,
        });
        setErrors((prevErrors) => ({
            ...prevErrors,
            [name]: undefined,
        }));
        if (file) {
            setUploadedFile(file);
            setOldImage(URL.createObjectURL(file));
        }
    };
    const filteredColors = apiData?.filter((color) => {
        const query = searchQuery.toLowerCase();

        return (
            color.name?.toLowerCase().includes(query) ||
            color.category?.toLowerCase().includes(query) ||
            color.CollectionName?.toLowerCase().includes(query) ||
            color.Layouts?.toLowerCase().includes(query) ||
            (color.grain ? "yes" : "no").includes(query) ||
            color.StyleName?.toLowerCase().includes(query)
        );
    });

    // 2. Pagination slice
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = filteredColors?.slice(indexOfFirstItem, indexOfLastItem) || [];

    // 3. total pages
    const totalPages = Math.ceil((filteredColors?.length || 0) / itemsPerPage);




    const validateForm = () => {
        const errors = {};
        const selectedGroup = groupedOptions.find(opt => opt.value === formData.group);
        const isCabinets = selectedGroup?.label === "Cabinets";

        // Always-required fields
        if (!formData.name?.trim()) {
            errors.name = "Color name is required";
        }
        
        if (!formData.group?.trim()) {
            errors.group = "Group is required";
        }
       
        if (!formData.layout || formData.layout.length === 0) {
            errors.layout = "At least one layout is required";
        }

        // Cabinets-only fields
        if (isCabinets) {
            if (!formData.collection) {
                errors.collection = "Collection is required";
            }
            if (!formData.color_code?.trim()) {
            errors.color_code = "Color code is required";
            }
            if (!formData.visualizer_style_type_id) {
                errors.visualizer_style_type_id = "Style Type is required";
            }
            if (!formData.texture_file && !formData.texture_file_path) {
                errors.texture_file = "Texture image is required";
            }
        } else {
            if (!formData.texture_file && !formData.texture_file_path) {
                errors.texture_file = "Texture image is required";
            }
        }

        setErrors(errors);
        return Object.keys(errors).length === 0;
    };




    const handleSubmitColorData = async () => {
        if (!validateForm()) {
            toast.error("Please fill all the fields");
            return;
        }

        try {
            setSubmitLoading(true);

            const formDataToSend = new FormData();
            formDataToSend.append("name", formData.name || "");
            formDataToSend.append("grain", formData.rerender || "0");
            //formDataToSend.append("grain", "0");
            formDataToSend.append("category", formData.group || "");
            formDataToSend.append("collection_id", formData.collection || "");
            formDataToSend.append("color_code", formData.color_code || "");
            formDataToSend.append("is_high_gloss", formData.is_high_gloss || "0");
            formDataToSend.append(
                "layouts",
                formData.layout?.length ? formData.layout.join(",") : ""
            );
            formDataToSend.append("style_id", formData.visualizer_style_type_id || "");
           // formDataToSend.append(
    //"api_collection_id",
    //formData.api_collection_id || ""
//);
            if (formData.texture_file instanceof File) {
                formDataToSend.append("texture_file", formData.texture_file);
            } else if (formData.texture_file_path) {
                formDataToSend.append("texture_file_path", formData.texture_file_path);
            }

            const url = `${process.env.REACT_APP_API_URL}/visualizer/addcolor`;

            const response = await fetch(url, {
                method: "POST",
                headers: {
                    Authorization: `Bearer ${token}`,
                },
                body: formDataToSend,
            });

            const result = await response.json();

            if (result?.Result == 1) {
                toast.success(formData.id ? "Color updated successfully!" : "Color added successfully!");
                await fetchColorsDetails();
                resetFormData();
                setAddColorPopup(false);
            } else {
                toast.error(formData.id ? "Failed to update color" : "Failed to add color");
            }
        } catch (error) {
            console.error("Add Color Error:", error);
            toast.error("Something went wrong");
        } finally {
            setSubmitLoading(false);
        }
    };





    // Apply filter
    const filteredItems = (
        (currentItems || [])
    ).map((item, index) => {
        let saveStatus = "selectable"; // default

        if (index === 0) saveStatus = "inProgress";
        if (index === 1) saveStatus = "saved";
        if (index === 2) saveStatus = "rendered";

        return {
            ...item,
            saveStatus,
        };
    });

    const handleBulkReRender = () => {
        if (selectedRows.length === 0) {
            alert("Please select at least one row.");
            return;
        }
        if (window.confirm("Re-render selected rows?")) {
            setInProgressRows(prev => [...prev, ...selectedRows]);


        }
    };

    const [rowLayouts, setRowLayouts] = useState({});
    const [rowCategories, setRowCategories] = useState({});
    const handleEdit = (img) => {

        setEditImage(img);
        if (img.ThumnnailImage) {
            setPreviewImage(img.ThumnnailImage);
        } else {
            setPreviewImage(null);
        }
    };


    const groupedOptions = Object.values(
        groups.reduce((acc, g) => {
            if (!acc[g.category]) {
                acc[g.category] = {
                    label: g.category,
                    value: g.label
                };
            } else {
                acc[g.category].value += `,${g.label}`;
            }
            return acc;
        }, {})
    );


    const updateColorStatus = async (id, currentStatus) => {
        const confirmUpdate = window.confirm("Do you want to update the status?");
        if (!confirmUpdate) return;
        const baseURl = process.env.REACT_APP_API_URL;
        const apiPath = '/visualizer/updatecolorstatus';
        const url = `${baseURl}${apiPath}`;
        const newStatus = currentStatus === 'Active' ? "De-active" : "Active";
        const requestBody = { id: id, status: newStatus };
        try {
            setLoading(true);
            const response = await API(url, requestBody, token);

            if (response && response.Result_value) {
                toast.success('Status Updated Succesfully!');
                fetchColorsDetails();
            }
        } catch (error) {
            console.error('Error during authentication:', error);
        } finally {
            setLoading(false);
        }
    };

    const deleteColor = async (id) => {
        const confirmDelete = window.confirm("Are you sure you want to delete this color?");
        if (!confirmDelete) return;

        const baseURl = process.env.REACT_APP_API_URL;
        const apiPath = "/visualizer/deletecolor";
        const url = `${baseURl}${apiPath}`;
        const requestBody = { id };

        try {
            setLoading(true);
            const response = await API(url, requestBody, token);

            if (response && response.Result_value) {
                toast.success("Color deleted successfully!");
                fetchColorsDetails();
            }
        } catch (error) {
            console.error("Error deleting color:", error);
            toast.error("Failed to delete color");
        } finally {
            setLoading(false);
        }
    };

    const handleUpdate = async (previewImage) => {
        if (!uploadedFile || !editImage) {
            toast.success("Please select a new image before updating.");
            return;
        }

        const baseURl = process.env.REACT_APP_API_URL;
        const apiPath = "/visualizer/changeassetcolor";
        const url = `${baseURl}${apiPath}`;
        const formData = new FormData();
        formData.append("asset_image", previewImage);
        formData.append("asset_file", uploadedFile);


        try {
            setLoading(true);
            const response = await API(url, formData, token);


            if (response && response.Result_value) {
                toast.success("Color image updated successfully!");
                setLoading(false);
                setEditImage(null);
                setPreviewImage(null);
                setUploadedFile(null);
                window.location.reload();
            }
        } catch (error) {
            console.error("Error deleting color:", error);
            toast.error("Failed to delete color");
        } finally {
            setLoading(false);
        }
    };

const handleColorCodeUpdate = async (item) => {
    const baseURl = process.env.REACT_APP_API_URL;
    const url = `${baseURl}/visualizer/updatecolorcode`; // adjust endpoint as needed
    try {
        const response = await API(url, { id: item.id, color_code: editingColorCodeValue }, token);
        if (response && response.Result_value) {
            toast.success('Color code updated!');
            fetchColorsDetails();
        } else {
            toast.error('Failed to update color code');
        }
    } catch (error) {
        toast.error('Error updating color code');
    } finally {
        setEditingColorCode(null);
        setEditingColorCodeValue('');
    }
};

    return (
        <>
            {loading || submitLoading || deleteLoading || orderUpdating || addCategoryLoading && (
                <div className="fixed inset-0 z-50 flex items-center justify-center bg-neutral-900/80">
                    <BeatLoader size={20} />
                </div>
            )}

            {submitLoading && (
                <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
                    <BeatLoader color="#fff" size={12} />
                </div>
            )}

            <Toaster position="top-center" />
            <div className="flex h-screen fixed w-full">
                <div className="md:w-64 w-16 bg-black transition-all">
                    <Sidebar />
                </div>
                <div className="flex flex-col flex-1 min-h-full">
                    <div className="bg-gray-100 flex-1 p-4 overflow-auto min-h-full">
                        <div className="bg-white rounded-2xl w-full flex flex-col min-h-full">
                            {/* Header Section */}
                            <div className="flex justify-between items-center px-6 pt-4">
                                <div>
                                    <p className="text-teal-500 text-xl font-semibold flex items-center gap-3">
                                        Colors
                                        {/*} <span>
                                            <IoInformationCircleSharp
                                                onClick={() => setPopup(true)}
                                                color='red'
                                                className='cursor-pointer'
                                            />
                                        </span>*/}
                                    </p>
                                    <p className="text-gray-600 mb-4">
                                        <span className="text-teal-500">
                                            <Link to="/admin/layouts" className="hover:text-teal-600 transition">Layout</Link>
                                        </span>
                                        <span className="text-gray-500"> / Details</span>
                                    </p>
                                </div>

                                <IoMdArrowBack
                                    style={{ width: "32px", height: "32px", color: "gray", cursor: "pointer" }}
                                    title="Back"
                                    onClick={() => navigate('/admin/layouts')}
                                />

                            </div>
                            <hr className="border-gray-200" />

                            {/* Details Section */}
                            <div className="bg-white rounded-2xl w-full h-full px-4 flex-1 flex flex-col justify-between">
                                <div className="mb-4 flex-1">
                                    <div className="mx-auto text-xs md:text-base">

                                        {/* Tabs for Categories */}
                                        <div className="p-6">






                                            {/* Add Color Button */}
                                            <div className="flex justify-between items-center mt-4">
                                                <div className="flex items-center gap-6 w-[400px]">
                                                    {/* Select All 
                                                    <label className="flex items-center gap-2">
                                                        <input
                                                            type="checkbox"
                                                            checked={selectAll}
                                                            onChange={handleSelectAll}
                                                        />
                                                        Select All
                                                    </label>*/}

                                                    {/* Show Re-render only if any checkbox is selected */}
                                                    {(selectedRows.length > 0 || selectAll) && (
                                                        <button
                                                            onClick={handleBulkReRender}
                                                            className="bg-gradient-to-r from-teal-400 to-teal-500 text-white px-3 py-1 rounded hover:from-teal-500 hover:to-teal-600 transition shadow-md"
                                                        >
                                                            ♻️ Re-render
                                                        </button>
                                                    )}
                                                    <input
                                                        type="text"
                                                        placeholder="Search...."
                                                        value={searchQuery}
                                                        onChange={(e) => {
                                                            setSearchQuery(e.target.value);
                                                            setCurrentPage(1);
                                                        }}
                                                        className="w-full p-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-teal-500"
                                                    />
                                                </div>






                                                <button
                                                    onClick={() => setAddColorPopup(true)}
                                                    className="flex items-center gap-2 bg-gradient-to-r from-teal-400 to-teal-500 text-white rounded-lg px-3 py-2 hover:from-teal-500 hover:to-teal-600 transition shadow-md"
                                                >
                                                    <FaPlus className="text-lg" />
                                                    Add Color
                                                </button>


                                            </div>

                                            {/* Table View */}
                                            <div className="overflow-x-auto">



                                                <table className="w-full mt-4 border-collapse bg-white rounded-lg shadow-md">
                                                    <thead className="bg-blue-100 text-gray-800">
                                                        <tr>
                                                            {/*<th className="p-3 text-start">Select</th>*/}
                                                            <th className="p-3 text-start">Thumbnail</th>
                                                            <th className="p-3 text-start">Color Name</th>
                                                            <th className="p-3 text-start">Group</th>
                                                            <th className="p-3 text-start">Collection</th>
                                                            <th className="p-3 text-start">Grain</th>
                                                            <th className="p-3 text-start">Layout</th>
                                                            <th className="p-3 text-start">Style Name</th>
                                                            <th className="p-3 text-start">Color Code</th>
                                                            <th className="p-3 text-start">Status</th>
                                                            <th className="p-3 text-start">Actions</th>
                                                        </tr>
                                                    </thead>

                                                    {colorLoading ? (
                                                        <tbody>
                                                            <tr>
                                                                <td colSpan="9">
                                                                    <div className="flex m-auto justify-center items-center py-8">
                                                                        <BeatLoader color="#14b8a6" />
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    ) : currentItems?.length > 0 ? (
                                                        <tbody>
                                                            {currentItems.map((item, index) => {
                                                                const isInProgress = inProgressRows.includes(item.id);
                                                                const layoutsForRow = rowLayouts[item.id] || [];
                                                                return (
                                                                    <tr
                                                                        key={item.id}
                                                                        className={`${item.status === "De-active"
                                                                            ? "bg-gray-300 opacity-50 cursor-not-allowed"
                                                                            : "border-b hover:bg-gray-50"
                                                                            } ${isInProgress ? "opacity-50 cursor-not-allowed" : ""}`}
                                                                    >



                                                                        {/* Index */}

                                                                        {/*  <td className="p-3">
                                                                            {isInProgress ? (
                                                                                // In Progress Spinner
                                                                                <span className="flex items-center gap-2 text-gray-500">
                                                                                    <svg className="animate-spin h-5 w-5" viewBox="0 0 24 24">
                                                                                        <circle
                                                                                            className="opacity-25"
                                                                                            cx="12"
                                                                                            cy="12"
                                                                                            r="10"
                                                                                            stroke="currentColor"
                                                                                            strokeWidth="4"
                                                                                            fill="none"
                                                                                        />
                                                                                        <path
                                                                                            className="opacity-75"
                                                                                            fill="currentColor"
                                                                                            d="M4 12a8 8 0 018-8v8z"
                                                                                        />
                                                                                    </svg>
                                                                                    In Progress
                                                                                </span>
                                                                            ) : item.saveStatus === "saved" ? (
                                                                                // Saved icon
                                                                                <span className="flex items-center gap-1 text-blue-600">
                                                                                    <FaCheck /> Saved
                                                                                </span>
                                                                            ) : item.saveStatus === "rendered" ? (
                                                                                // Rendered icon
                                                                                <span className="flex items-center gap-1 text-green-600">
                                                                                    ♻️ Rendered
                                                                                </span>
                                                                            ) : (
                                                                                // Normal checkbox
                                                                                <input
                                                                                    type="checkbox"
                                                                                    checked={selectedRows.includes(item.id)}
                                                                                    onChange={() => handleSelectRow(item.id)}
                                                                                />
                                                                            )}
                                                                        </td>*/}

                                                                        {/* Thumbnail / In-progress */}
                                                                        <td className="p-3">
                                                                            <div className="relative inline-block">
                                                                                <img
                                                                                    src={item.ThumnnailImage}
                                                                                    alt="thumbnail"
                                                                                    className="w-[90px] h-[90px] object-cover cursor-pointer rounded shadow"
                                                                                    onClick={() => {
                                                                                        setPreviewImage(item.ThumnnailImage);
                                                                                        setIsImageModalOpen(true);
                                                                                    }}
                                                                                />

                                                                                {/* Edit Icon */}
                                                                                <button
                                                                                    onClick={() => handleEdit(item)}
                                                                                    className="absolute top-1 right-1 bg-white rounded-full p-1 shadow hover:bg-gray-100"
                                                                                >
                                                                                    <FiEdit size={12} className="text-gray-700" />
                                                                                </button>

                                                                                {/* Zoom Icon */}
                                                                                <button
                                                                                    onClick={() => setZoomImage(item.ThumnnailImage)}
                                                                                    className="absolute top-8 right-1 bg-white rounded-full p-1 shadow hover:bg-gray-100"
                                                                                    title="Zoom"
                                                                                >
                                                                                    <FiZoomIn size={12} className="text-gray-700" />
                                                                                </button>
                                                                            </div>
                                                                        </td>



                                                                        <td>
                                                                            {item.name}
                                                                        </td>
                                                                        <td className="p-3">
                                                                            <div className="flex flex-wrap gap-2 items-center">
                                                                                {item.category
                                                                                    ?.split(",")
                                                                                    .map(cat => cat.trim())
                                                                                    .filter(cat => cat.length)
                                                                                    .map((cat, idx) => (
                                                                                        <span
                                                                                            key={idx}
                                                                                            className="bg-gray-200 text-gray-700 text-xs px-2 py-1 rounded mr-1"
                                                                                        >
                                                                                            {cat}
                                                                                        </span>
                                                                                    ))}

                                                                            </div>
                                                                        </td>
                                                                        <td>
                                                                            {item.CollectionName}
                                                                        </td>
                                                                        <td>
                                                                            {item.grain ? 'Yes' : 'No'}
                                                                        </td>
                                                                        <td className="p-3">
                                                                            <div className="flex flex-wrap gap-2 items-center">

                                                                                {item.Layouts
                                                                                    ?.split(",")
                                                                                    .map((layout) => layout.trim())
                                                                                    .filter((layout) => layout.length)
                                                                                    .map((layout, idx) => {
                                                                                        const [name, status] = layout.split("##");
                                                                                        let classes = "text-xs px-2 py-1 rounded mr-1 flex items-center gap-1";
                                                                                        if (status === "Active") classes += " bg-green-200 text-green-800 font-semibold";
                                                                                        else if (status === "Inactive") classes += " bg-gray-200 text-gray-500 line-through";
                                                                                        else if (status === "Progress") classes += " bg-gray-200 text-gray-800";
                                                                                        else classes += " bg-gray-200 text-gray-700";

                                                                                        return (
                                                                                            <span key={idx} className={classes}>
                                                                                                {name}
                                                                                                {status === "Progress" && (
                                                                                                    <svg className="animate-spin h-3 w-3 text-gray-600" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                                                                                        <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                                                                                                        <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"></path>
                                                                                                    </svg>
                                                                                                )}
                                                                                            </span>
                                                                                        );
                                                                                    })}

                                                                                {/* Plus button */}
                                                                                {(() => {
                                                                                    const existingLayouts = item.Layouts ? item.Layouts.split(",").map((l) => l.trim().split("##")[0]) : [];
                                                                                    const unusedLayouts = layouts.filter((opt) => !existingLayouts.includes(opt.name || opt));

                                                                                    if (!unusedLayouts.length) return null;

                                                                                    return (
                                                                                        <button
                                                                                            onClick={() => {
                                                                                                setRowAddingLayout(item.id);
                                                                                                setShowLayoutModal(true);
                                                                                                setNewLayouts([]);
                                                                                            }}
                                                                                            className="text-teal-500 text-lg font-bold"
                                                                                            title="Add Layout"
                                                                                        >
                                                                                            +
                                                                                        </button>
                                                                                    );
                                                                                })()}
                                                                            </div>

                                                                            {/* Layout Modal */}
                                                                            {showLayoutModal && rowAddingLayout === item.id && (
                                                                                <div className="fixed inset-0 bg-black bg-opacity-30 flex justify-center items-center z-50">
                                                                                    <div className="bg-white p-5 rounded shadow-lg w-96">
                                                                                        <h3 className="text-lg font-semibold mb-3">Add Layouts</h3>

                                                                                        <Select
                                                                                            options={layouts
                                                                                                .filter((opt) => !item.Layouts?.includes(opt.name))
                                                                                                .map((opt) => ({ value: opt.id, label: opt.name }))}
                                                                                            isMulti
                                                                                            closeMenuOnSelect={false}
                                                                                            hideSelectedOptions={false}
                                                                                            components={{ Option: OptionWithCheckbox }}
                                                                                            onChange={(selected) => setNewLayouts(selected ? selected.map((s) => s.value) : [])}
                                                                                            value={newLayouts.map((id) => {
                                                                                                const layoutObj = layouts.find(l => l.id === id);
                                                                                                return { value: id, label: layoutObj?.name || id };
                                                                                            })}
                                                                                            autoFocus
                                                                                        />



                                                                                        <div className="flex justify-end gap-2 mt-4">


                                                                                            <button
                                                                                                onClick={async () => {
                                                                                                    const baseURl = process.env.REACT_APP_API_URL;
                                                                                                    const apiPath = "/visualizer/addlayoutincolor";
                                                                                                    const url = `${baseURl}${apiPath}`;

                                                                                                    try {

                                                                                                        for (const layout of newLayouts) {
                                                                                                            await axios.post(
                                                                                                                url,
                                                                                                                {
                                                                                                                    color_id: item.id,
                                                                                                                    layout_id: layout,
                                                                                                                },
                                                                                                                {
                                                                                                                    headers: {
                                                                                                                        'Content-Type': 'application/json',
                                                                                                                        Accept: 'application/json',
                                                                                                                        'Authorization': `Bearer ${token}`,
                                                                                                                    },
                                                                                                                }
                                                                                                            );
                                                                                                        }


                                                                                                        setRowLayouts({
                                                                                                            ...rowLayouts,
                                                                                                            [item.id]: [...(rowLayouts[item.id] || []), ...newLayouts],
                                                                                                        });
                                                                                                        setNewLayouts([]);
                                                                                                        setShowLayoutModal(false);
                                                                                                        setRowAddingLayout(null);
                                                                                                        toast.success("Layout added successfully!");

                                                                                                         fetchColorsDetails();
                                                                                                    } catch (error) {
                                                                                                        console.error("Error adding layouts:", error);

                                                                                                    }
                                                                                                }}
                                                                                                className="bg-teal-500 text-white text-xs px-3 py-1 rounded"
                                                                                            >
                                                                                                Add
                                                                                            </button>


                                                                                            <button
                                                                                                onClick={() => {
                                                                                                    setShowLayoutModal(false);
                                                                                                    setRowAddingLayout(null);
                                                                                                }}
                                                                                                className="bg-gray-400 text-white text-xs px-3 py-1 rounded"
                                                                                            >
                                                                                                Cancel
                                                                                            </button>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            )}
                                                                        </td>


                                                                        <td className="p-3">{item?.StyleName}</td>
                                                                        <td className="p-3">
   
        <div className="flex items-center gap-2">
            <span className="text-sm text-gray-700">
                {item.color_code || '—'}
            </span>
            
        </div>
    
</td>

                                                                        <td className="p-3">
                                                                            {(() => {
                                                                                    const layoutsArray = (item.Layouts || "")
                                                                                        .split(",")
                                                                                        .map(l => l.trim())
                                                                                        .filter(l => l.length);


                                                                                    const statuses = layoutsArray.map(l => l.split("##")[1]?.trim() || "");


                                                                                    const hasProgress = statuses.some(status => status === "Progress");

                                                                                    if (!hasProgress) {
                                                                                        return (
                                                                                           <button
                                                                                disabled={!item.status}
                                                                                onClick={() => updateColorStatus(item.id, item.status)}
                                                                                className={`px-3 py-1 rounded text-white text-sm font-medium 
                                                                                  ${item.status !== 'De-active' ? "bg-green-500 hover:bg-green-600" : "bg-red-500"} 
                                                                                  `}
                                                                            >
                                                                                {item.status === "Active" ? "Active" : "Inactive"}
                                                                            </button>
                                                                                        );
                                                                                    }


                                                                                    return null;
                                                                                })()}
                                                                            
                                                                        </td>

                                                                        <td className="p-3 flex gap-2 mt-4">
                                                                            {/* <button
                                                                                className="text-blue-500 hover:underline"
                                                                                title="Edit Color"
                                                                                onClick={() => {
                                                                                    const data = item; // API response row

                                                                                    setFormData({
                                                                                        id: data.id,
                                                                                        name: data.name || "",
                                                                                        layout: data.Layouts
                                                                                            ? data.Layouts.split(",").map(l => l.split("##")[0])
                                                                                            : [],
                                                                                        group: data.category || "",
                                                                                        collection: data.collection_id || "",
                                                                                        visualizer_style_type_id: data.style_id || "",
                                                                                        is_default: data.is_default ? "1" : "0",
                                                                                        have_grain: data.grain ? "1" : "0",
                                                                                        texture_file: null,
                                                                                        texture_file_path: data.TextureImage || "",
                                                                                        status: data.status === "Active" ? "1" : "0",
                                                                                    });

                                                                                    setAddColorPopup(true);
                                                                                }}
                                                                            >
                                                                                <FaEdit size={20} />
                                                                            </button>*/}
                                                                            <td className="p-3 flex gap-2 items-center">
                                                                                {(() => {
                                                                                    const layoutsArray = (item.Layouts || "")
                                                                                        .split(",")
                                                                                        .map(l => l.trim())
                                                                                        .filter(l => l.length);


                                                                                    const statuses = layoutsArray.map(l => l.split("##")[1]?.trim() || "");


                                                                                    const hasProgress = statuses.some(status => status === "Progress");

                                                                                    if (!hasProgress) {
                                                                                        return (
                                                                                            <button
                                                                                                title="Delete Color"
                                                                                                className="px-3 py-1 rounded text-sm font-medium text-red-500 hover:underline"
                                                                                                onClick={() => {
                                                                                                    deleteColor(item.id);
                                                                                                    setColorToDelete(item.id);
                                                                                                    setShowDeleteModal(true);
                                                                                                }}
                                                                                            >
                                                                                                <MdOutlineDeleteOutline size={20} />
                                                                                            </button>
                                                                                        );
                                                                                    }


                                                                                    return null;
                                                                                })()}
                                                                            </td>





                                                                        </td>

                                                                    </tr>
                                                                );
                                                            })}
                                                        </tbody>
                                                    ) : (
                                                        <tbody>
                                                            <tr>
                                                                <td
                                                                    colSpan="9"
                                                                    className="py-12 text-lg text-center text-gray-500"
                                                                >
                                                                    No colors found.
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    )}
                                                </table>


                                            </div>
                                            {currentItems?.length > 0 && (
                                                <div className="flex justify-center items-center gap-4 mt-4">
                                                    <button
                                                        onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
                                                        disabled={currentPage === 1}
                                                        className="px-4 py-2 bg-gray-300 text-gray-800 rounded hover:bg-gray-400 disabled:opacity-50"
                                                    >
                                                        <GrPrevious />
                                                    </button>

                                                    <span className="text-gray-700">
                                                        Page {currentPage} of {totalPages}
                                                    </span>

                                                    <button
                                                        onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))}
                                                        disabled={currentPage === totalPages}
                                                        className="px-4 py-2 bg-gray-300 text-gray-800 rounded hover:bg-gray-400 disabled:opacity-50"
                                                    >
                                                        <GrNext />
                                                    </button>
                                                </div>
                                            )}

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>


                {/* Add Color Popup Modal */}
                {addColorPopup && (
                    <div className="fixed inset-0 flex justify-center items-center bg-gray-500 bg-opacity-75">
                        <div className="relative bg-white p-6 h-[90%] w-3/4 md:w-[70%] shadow-lg">
                
                            {/* Close Cross Button */}
                            <button
                                onClick={() => {
                                    setAddColorPopup(false);
                                    resetFormData();
                                }}
                                className="absolute top-3 right-3 text-2xl font-bold   px-3 py-1 bg-red-500 text-white rounded-full hover:bg-red-600"
                            >
                                &times;
                            </button>
                
                            <h2 className="text-2xl font-bold mb-6 text-center">
                                {formData.id ? `Edit  Color` : `Add  Color`}
                            </h2>
                
                            <div className='h-[80%] overflow-auto'>
                
                                <div className="flex-1 ">
                                    {/* 1st gRDI */}
                                    {(() => {
                                        const selectedGroup = groupedOptions.find(
                                            (opt) => opt.value === formData.group
                                        );
                                        const isCabinets = selectedGroup?.label === "Cabinets";
                
                                        return (
                                            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                                                <div className="mb-6 p-5 pl-3 ml-5">
                                                    <label htmlFor="name" className="block text-sm font-semibold mb-2 text-gray-700">Color Name<span className="text-red-500">*</span></label>
                                                    <input
                                                        type="text"
                                                        name="name"
                                                        value={formData.name}
                                                        onChange={handleChange}
                                                        className="block w-full py-2 px-1 text-gray-900 bg-transparent border-0 border-b-2 border-gray-300 focus:outline-none focus:ring-0 focus:border-blue-600"
                                                        placeholder="Enter Color Name"
                                                    />
                                                    {errors.name && <p className="text-red-500 text-xs italic mt-2">{errors.name}</p>}
                                                </div>
                
                                                <div className="mb-6 p-5 pl-3 ml-5">
                                                    <label htmlFor="childCategory" className="block text-sm font-semibold mb-2 text-gray-700">
                                                        Layout<span className="text-red-500">*</span>
                                                    </label>
                                                    <Select
                                                        isMulti
                                                        name="layout"
                                                        options={layouts.map((l) => ({ value: l.id, label: l.name }))}
                                                        value={
                                                            formData.layout?.map((id) => {
                                                                const match = layouts.find((l) => l.id === id);
                                                                return match ? { value: match.id, label: match.name } : null;
                                                            }).filter(Boolean) || []
                                                        }
                                                        onChange={(selected) => {
                                                            const newValues = selected.map((s) => s.value);
                
                                                            setFormData({
                                                                ...formData,
                                                                layout: newValues,
                                                            });
                
                                                            if (newValues.length > 0 && errors.layout) {
                                                                setErrors((prev) => {
                                                                    const { layout, ...rest } = prev;
                                                                    return rest;
                                                                });
                                                            }
                                                        }}
                                                        className="basic-single-select w-full"
                                                        classNamePrefix="select"
                                                        menuPortalTarget={document.body}
                                                        styles={{
                                                            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                                            control: (base) => ({
                                                                ...base,
                                                                border: "none",
                                                                borderBottom: "2px solid #ccc",
                                                                borderRadius: 0,
                                                                boxShadow: "none",
                                                                "&:hover": { borderBottom: "2px solid #3b82f6" },
                                                            }),
                                                        }}
                                                    />
                
                                                    {errors.layout && <p className="text-red-500 text-xs italic mt-2">{errors.layout}</p>}
                                                </div>
                                                {/* High Gloss toggle — always visible, no condition */}
                
                                            </div>
                                        );
                                    })()}
                
                                    {/* 2nd gRDI */}
                                    <div
                                        className={`grid grid-cols-2 gap-6 ${(() => {
                                                const selectedGroup = groupedOptions.find(
                                                    (opt) => opt.value === formData.group
                                                );
                
                                                return selectedGroup?.label === "Cabinets"
                                                    ? "md:grid-cols-[5fr_5fr_2fr_2fr]"
                                                    : "md:grid-cols-2";
                                            })()
                                            }`}
                                    >
                                        {/* gROUp Field */}
                                        <div className="mb-6 p-5 pl-3 ml-5">
                                            <label className="block text-sm font-semibold mb-2 text-gray-700">
                                                Group<span className="text-red-500">*</span>
                                            </label>
                                            <Select
                                                name="group"
                                                isMulti={false}
                                                options={groupedOptions}
                                                value={
                                                    formData.group
                                                        ? groupedOptions.find((opt) => opt.value === formData.group) || null
                                                        : null
                                                }
                
                                                onChange={(selected) => {
                                                    setFormData({
                                                        ...formData,
                                                        group: selected ? selected.value : null,
                                                    });
                
                                                    setErrors((prev) => ({
                                                        ...prev,
                                                        group: null,
                                                    }));
                                                }}
                                                className="basic-single-select w-full"
                                                classNamePrefix="select"
                                                menuPortalTarget={document.body}
                                                styles={{
                                                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                                    control: (base) => ({
                                                        ...base,
                                                        border: "none",
                                                        borderBottom: "2px solid #ccc",
                                                        borderRadius: 0,
                                                        boxShadow: "none",
                                                        "&:hover": { borderBottom: "2px solid #3b82f6" },
                                                    }),
                                                }}
                                            />
                
                                            {errors.group && (
                                                <p className="text-red-500 text-xs italic mt-2">{errors.group}</p>
                                            )}
                                        </div>
                
                                        {(() => {
                                            const selectedGroup = groupedOptions.find(
                                                (opt) => opt.value === formData.group
                                            );
                
                                            if (selectedGroup?.label === "Cabinets") {
                
                                                // Use boolean for toggle
                                                const isGrain = formData.rerender === "1";
                
                                                return (
                                                    <>
                                                        <div className="mb-6 p-5 pl-3 ml-5">
                                                            <label className="block text-sm font-semibold mb-2 text-gray-700">
                                                                Collection<span className="text-red-500">*</span>
                                                            </label>
                                                            <Select
                                                                name="collection"
                                                                options={collections.map((c) => ({ value: c.id, label: c.name }))}
                                                                value={
                                                                    formData.collection
                                                                        ? {
                                                                            value: formData.collection,
                                                                            label: collections.find((c) => c.id === formData.collection)?.name || "",
                                                                        }
                                                                        : null
                                                                }
                
                                                                onChange={(selected) => {
                                                                    setFormData({
                                                                        ...formData,
                                                                        collection: selected ? selected.value : null,
                                                                    });
                
                                                                    setErrors((prev) => ({
                                                                        ...prev,
                                                                        collection: null,
                                                                    }));
                                                                }}
                                                                className="basic-single-select w-full"
                                                                classNamePrefix="select"
                                                                menuPortalTarget={document.body}
                                                                styles={{
                                                                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                                                    control: (base) => ({
                                                                        ...base,
                                                                        border: "none",
                                                                        borderBottom: "2px solid #ccc",
                                                                        borderRadius: 0,
                                                                        boxShadow: "none",
                                                                        "&:hover": { borderBottom: "2px solid #3b82f6" },
                                                                    }),
                                                                }}
                                                            />
                
                                                            {errors.collection && (
                                                                <p className="text-red-500 text-xs italic mt-2">{errors.collection}</p>
                                                            )}
                                                        </div>
                                                        <div className="mb-6 p-5 pl-3 ml-5">
                                                            <label className="block text-sm font-semibold mb-3 text-gray-700">
                                                                Grain 
                                                            </label>
                
                                                            <div className="flex items-center gap-3">
                                                                <span className={`text-sm font-medium ${isGrain ? "text-green-600" : "text-gray-500"}`}>
                                                                    {isGrain ? "Yes" : "No"}
                                                                </span>
                
                                                                <button
                                                                    type="button"
                                                                    onClick={() =>
                                                                        setFormData((prev) => ({
                                                                            ...prev,
                                                                            rerender: prev.rerender === "1" ? "0" : "1", // toggle
                                                                        }))
                                                                    }
                                                                    className={`relative inline-flex h-6 w-12 items-center rounded-full transition ${isGrain ? "bg-green-500" : "bg-gray-300"
                                                                        }`}
                                                                >
                                                                    <span
                                                                        className={`inline-block h-5 w-5 transform rounded-full bg-white transition ${isGrain ? "translate-x-6" : "translate-x-1"
                                                                            }`}
                                                                    />
                                                                </button>
                                                            </div>
                                                        </div>
                                                        <div className="mb-6 p-5 pl-3 ml-5">
                                                            <label className="block text-sm font-semibold mb-3 text-gray-700">
                                                                High Gloss 
                                                            </label>
                
                                                            <div className="flex items-center gap-3">
                                                                <span className={`text-sm font-medium ${formData.is_high_gloss === "1" ? "text-green-600" : "text-gray-500"}`}>
                                                                    {formData.is_high_gloss === "1" ? "Yes" : "No"}
                                                                </span>
                
                                                                <button
                                                                    type="button"
                                                                    onClick={() =>
                                                                        setFormData((prev) => ({
                                                                            ...prev,
                                                                            is_high_gloss: prev.is_high_gloss === "1" ? "0" : "1",
                                                                        }))
                                                                    }
                                                                    className={`relative inline-flex h-6 w-12 items-center rounded-full transition ${formData.is_high_gloss === "1" ? "bg-green-500" : "bg-gray-300"
                                                                        }`}
                                                                >
                                                                    <span
                                                                        className={`inline-block h-5 w-5 transform rounded-full bg-white transition ${formData.is_high_gloss === "1" ? "translate-x-6" : "translate-x-1"
                                                                            }`}
                                                                    />
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </>
                
                                                );
                                            } else {
                                                return (
                                                    <div className="mb-6 p-5 pl-3 ml-5">
                                                        <label className="block text-sm font-semibold mb-2 text-gray-700">
                                                            Texture: <span className="text-red-500">*</span>
                                                        </label>
                
                                                        <div className="flex items-center gap-6">
                                                            <div className="relative w-1/3">
                                                                {(formData.texture_file || formData.texture_file_path) ? (
                                                                    <div className="relative">
                                                                        <img
                                                                            src={
                                                                                formData.texture_file
                                                                                    ? URL.createObjectURL(formData.texture_file)
                                                                                    : formData.texture_file_path
                                                                            }
                                                                            alt="Preview"
                                                                            className="h-24 w-full object-contain rounded"
                                                                        />
                
                                                                    </div>
                                                                ) : (
                                                                    <div className="h-24 w-full flex items-center justify-center border rounded bg-gray-100 text-gray-400 text-xs">
                                                                        No Image
                                                                    </div>
                                                                )}
                                                            </div>
                
                                                            <div className="flex-1">
                                                                <input
                                                                    type="file"
                                                                    accept=".jpg,.png"
                                                                    onChange={(e) =>
                                                                        setFormData({
                                                                            ...formData,
                                                                            texture_file: e.target.files[0],
                                                                            texture_file_path: null,
                                                                        })
                                                                    }
                                                                    className="block w-full py-2 px-1 text-gray-900 bg-transparent border-0 border-b-2 border-gray-300 focus:outline-none focus:ring-0 focus:border-blue-600"
                                                                />
                                                                <p className="text-xs text-gray-500 mt-1 pl-1 text-center">
                                                                    Only image files (.jpg,.png) are allowed.
                                                                </p>
                                                                {errors.texture_file && (
                                                                    <p className="text-red-500 text-xs italic mt-2">
                                                                        {errors.texture_file}
                                                                    </p>
                                                                )}
                                                            </div>
                                                        </div>
                                                    </div>
                                                );
                                            }
                                        })()}
                
                                    </div>
                                    {(() => {
                                        const selectedGroup = groupedOptions.find(
                                            (opt) => opt.value === formData.group
                                        );
                
                                        if (selectedGroup?.label === "Cabinets") {
                
                                            // Use boolean for toggle
                                            const isGrain = formData.rerender === "1";
                
                                            return (
                                                <div className="grid grid-cols-1 md:grid-cols-[2fr_2fr_3fr] gap-6">
                                                    <div className="mb-6 p-5 pl-3 ml-5">
                                                        <label htmlFor="childCategory" className="block text-sm font-semibold mb-2 text-gray-700">
                                                            Style Type<span className="text-red-500">*</span>
                                                        </label>
                                                        <Select
                                                            name="styleType"
                                                            options={stylesOption.map((s) => ({ value: s.id, label: s.name }))}
                                                            value={formData.visualizer_style_type_id
                                                                ? {
                                                                    value: formData.visualizer_style_type_id,
                                                                    label: stylesOption.find((s) => s.id === formData.visualizer_style_type_id)?.name || "",
                                                                }
                                                                : null
                                                            }
                                                            onChange={(selected) => {
                                                                setFormData({
                                                                    ...formData,
                                                                    visualizer_style_type_id: selected ? selected.value : null,
                                                                });
                
                                                                setErrors((prev) => ({
                                                                    ...prev,
                                                                    visualizer_style_type_id: null,
                                                                }));
                                                            }}
                                                            className="basic-single-select w-full"
                                                            classNamePrefix="select"
                                                            menuPortalTarget={document.body}
                                                            styles={{
                                                                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                                                control: (base) => ({
                                                                    ...base,
                                                                    border: "none",
                                                                    borderBottom: "2px solid #ccc",
                                                                    borderRadius: 0,
                                                                    boxShadow: "none",
                                                                    "&:hover": { borderBottom: "2px solid #3b82f6" },
                                                                }),
                                                            }}
                                                        />
                
                                                        {errors.visualizer_style_type_id && <p className="text-red-500 text-xs italic mt-2">{errors.visualizer_style_type_id}</p>}
                                                    </div>
                                                    <div className="mb-6 p-5 pl-3 ml-5">
                                                        <label htmlFor="color_code" className="block text-sm font-semibold mb-2 text-gray-700">
                                                            Color Code<span className="text-red-500">*</span>
                                                        </label>
                                                        <input
                                                            type="text"
                                                            name="color_code"
                                                            value={formData.color_code}
                                                            onChange={handleChange}
                                                            className="block w-full py-2 px-1 text-gray-900 bg-transparent border-0 border-b-2 border-gray-300 focus:outline-none focus:ring-0 focus:border-blue-600"
                                                            placeholder="Enter Color Code"
                                                        />
                                                        {errors.color_code && <p className="text-red-500 text-xs italic mt-2">{errors.color_code}</p>}
                                                    </div>
                                                    <div className="mb-6 p-5 pl-3 ml-5">
                                                        <label className="block text-sm font-semibold mb-2 text-gray-700">
                                                            Texture: <span className="text-red-500">*</span>
                                                        </label>
                
                                                        <div className="flex items-center gap-6">
                                                            <div className="relative w-1/3">
                                                                {(formData.texture_file || formData.texture_file_path) ? (
                                                                    <div className="relative">
                                                                        <img
                                                                            src={
                                                                                formData.texture_file
                                                                                    ? URL.createObjectURL(formData.texture_file)
                                                                                    : formData.texture_file_path
                                                                            }
                                                                            alt="Preview"
                                                                            className="h-24 w-full object-contain rounded"
                                                                        />
                
                                                                    </div>
                                                                ) : (
                                                                    <div className="h-24 w-full flex items-center justify-center border rounded bg-gray-100 text-gray-400 text-xs">
                                                                        No Image
                                                                    </div>
                                                                )}
                                                            </div>
                
                                                            <div className="flex-1">
                                                                <input
                                                                    type="file"
                                                                    accept=".jpg,.png"
                                                                    onChange={(e) =>
                                                                        setFormData({
                                                                            ...formData,
                                                                            texture_file: e.target.files[0],
                                                                            texture_file_path: null,
                                                                        })
                                                                    }
                                                                    className="block w-full py-2 px-1 text-gray-900 bg-transparent border-0 border-b-2 border-gray-300 focus:outline-none focus:ring-0 focus:border-blue-600"
                                                                />
                                                                <p className="text-xs text-gray-500 mt-1 pl-1 text-center">
                                                                    Only image files (.jpg,.png) are allowed.
                                                                </p>
                                                                {errors.texture_file && (
                                                                    <p className="text-red-500 text-xs italic mt-2">
                                                                        {errors.texture_file}
                                                                    </p>
                                                                )}
                                                            </div>
                                                        </div>
                                                    </div>
                                                    
                
                                                </div>
                
                                            );
                                        } else {
                                            return null;
                                        }
                                    })()}
                
                                </div>
                
                            </div>
                
                            <div className="flex justify-end gap-4 mt-6">
                                {formData.id ? (
                                    <button
                                        onClick={() => {
                                            setAddColorPopup(false)
                                            resetFormData();
                                        }
                                        }
                                        className="p-2 bg-green-500 text-white rounded hover:bg-green-700"
                                    >
                                        Save
                                    </button>
                                ) : null}
                
                                <button
                                    onClick={handleSubmitColorData}
                                    className="p-2 bg-green-500 text-white rounded hover:bg-green-700"
                                >
                                    Save & Render
                                </button>
                
                            </div>
                
                        </div>
                    </div>
                )}
                {editImage && (
                    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-70">
                        <div className="relative bg-white rounded-lg shadow-lg max-w-lg w-[90%] p-6">
                            {/* Close Button */}
                            <button
                                onClick={() => {
                                    setEditImage(null);
                                    setPreviewImage(null);
                                }}
                                className="absolute top-2 right-2 text-white bg-red-500 rounded-full p-2 hover:bg-red-600"
                                title="Close"
                            >
                                <FiX size={18} />
                            </button>


                            <h4 className="text-lg font-semibold mb-4">
                                {previewImage
                                    ? previewImage.split("/").pop()
                                        .replace(/^\d+_/, "")
                                        .replace(/\.[^/.]+$/, "")
                                    : "No Image Selected"}
                            </h4>


                            <div className="flex items-center gap-6 mb-4">

                                <div className="w-32 h-32 border flex items-center justify-center bg-gray-100 text-gray-400 text-sm">
                                    {oldImage ? (
                                        <img
                                            src={oldImage}
                                            alt="Old Image"
                                            className="w-[90px] h-[90px] object-cover cursor-pointer rounded shadow"
                                        />
                                    ) : previewImage ? (
                                        <img
                                            src={previewImage}
                                            alt="Preview"
                                            className="w-[90px] h-[90px] object-cover cursor-pointer rounded shadow"
                                        />
                                    ) : (
                                        "No Image"
                                    )}
                                </div>

                                {/* Right: Upload */}
                                <div>

                                    <input
                                        type="file"
                                        accept=".webp"
                                        onChange={handleFileChange}
                                        className="block w-full py-2 px-1 text-gray-900 bg-transparent border-0 border-b-2 border-gray-300 focus:outline-none focus:ring-0 focus:border-blue-600"
                                    />
                                    <p className="text-xs text-gray-500 mt-1 text-center">
                                        Only WebP image files are allowed. The recommended size is 200 × 200 pixels.
                                    </p>
                                </div>
                            </div>

                            {/* Buttons */}
                            <div className="flex justify-end gap-3">
                                <button
                                    onClick={() => {
                                        setEditImage(null);
                                        setPreviewImage(null);
                                    }}
                                    className="px-4 py-2 bg-gray-300 text-gray-800 rounded hover:bg-gray-400"
                                >
                                    Cancel
                                </button>
                                <button
                                    onClick={() => handleUpdate(previewImage)}
                                    className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
                                >
                                    Update
                                </button>
                            </div>
                        </div>
                    </div>
                )}

                {zoomImage && (
                    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-70">
                        <div className="relative bg-white rounded-lg shadow-lg max-w-3xl w-[90%] p-4">
                            <button
                                onClick={() => setZoomImage(null)}
                                className="absolute top-2 right-2 text-white bg-red-500 rounded-full px-3 py-1 hover:bg-red-600"
                            >
                                ✖
                            </button>
                            <img
                                src={zoomImage}
                                alt="Zoomed"
                                className="w-full h-auto object-contain max-h-[80vh]"
                            />
                        </div>
                    </div>
                )}

            </div >
        </>
    );
};

export default ColorSelection;
